import React from 'react';
import { Link } from 'react-router-dom';

const Crumb = ({ to, title }) => (
  <li>
    {to ? (
      <Link to={to} title={title}>
        {title}
      </Link>
    ) : (
      title
    )}
  </li>
);

const Navbar = ({ breadcrumbs }) => {
  const hasBreadcrumbs = breadcrumbs && breadcrumbs.length;
  return (
    <div data-testid="navbar" className="navbar">
      <ul className="breadcrumbs">
        {hasBreadcrumbs ? (
          breadcrumbs.map(c => (
            <Crumb key={c.title} to={c.url} title={c.title} />
          ))
        ) : (
          <Crumb title="Pivot Analysis" />
        )}
      </ul>
      {/* <Link to={'/settings'} title="Settings" className="action">
      <i className="icon-gear" />
    </Link> */}
    </div>
  );
};

export default Navbar;
